<template>
  <div>
    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <label class="control-label require number-label">法人番号</label>
        <input class="form-control number-text" :class="{'is-invalid': errorsHash['number']}" type="text" v-model="corporateNumber" name="store[corporation_attributes][number]" id="store_corporation_attributes_number">
        <button type="button" class="btn btn-other-action number-search-btn" @click="openModal()">番号検索</button>
        <div v-if="errorsHash['number']" class="invalid-feedback">法人番号 {{ errorsHash['number'][0] }}</div>
      </div>
    </div>

    <base-modal v-if="showModal">
      <div class="modal-content">
        <div class="modal-header">
          <form class="form-inline" @submit.prevent="search">
            <label class="control-label mr-2" for="search_text">法人名検索</label>
            <input class="form-control" type="text" v-model="corporateName" id="search_text" />
          </form>
          <div class="modal-action">
            <a href="javascript:void()" @click="showModal = false">
              <span class="material-icons">close</span>
            </a>
          </div>
        </div>
        <div class="modal-body">
          <div v-if="onSearch" class="text-center">... 検索中です ...</div>
          <div v-else-if="searchResults.length === 0" class="text-center">検索結果がありません (´・ω・`)</div>
          <div v-else="searchResults.length > 0" class="list-group">
            <div class="text-center mb-1">2,000 件以上の結果は表示されません。</div>
            <div v-for="result in searchResults" class="list-group-item flex-column align-items-start">
              <div class="d-flex mb-1 w-100 justify-content-between">
                <h5 class="mb-1">{{ result["name"] }}</h5>
                <small>{{ result["corporate_number"] }}</small>
              </div>
              <ul class="list-unstyled ml-3">
                <li>{{ [result["prefecture_name"], result["city_name"], result["street_number"]].join(" ").trimEnd() }}</li>
              </ul>
              <div class="result-action text-right">
                <button type="button" class="btn btn-sm btn-edit" @click="openDetail(result['corporate_number'])"><span class="material-icons">open_in_new</span> 詳細</button>
                <button type="button" class="btn btn-sm btn-other-action" @click="applyResult(result)"><span class="material-icons">check</span> 選択</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer text-right">
        </div>
      </div>
    </base-modal>
  </div>
</template>

<script>
import BaseModal from '../modal/base_modal.vue'

export default {
  components: {
    BaseModal
  },
  data () {
    return {
      showModal: false,
      onSearch: false,
      searchResults: [],
      corporateName: null,
      // corporation: erb 上で宣言した定数
      corporateNumber: corporation['number'],
      errorsHash: corporation['errors']
    }
  },
  methods: {
    applyResult (selected) {
      const event = new Event('input', { bubbles: true })

      // すごく気持ち悪いけど、とりあえず動くから良いことにする。
      document.querySelector('#store_corporation_attributes_number').value = selected['corporate_number']
      document.querySelector('#store_corporation_attributes_number').dispatchEvent(event)

      document.querySelector('#store_corporation_attributes_name').value = selected['name']
      document.querySelector('#store_corporation_attributes_name').dispatchEvent(event)

      document.querySelector('#store_corporation_attributes_name_kana').value = selected['furigana']
      document.querySelector('#store_corporation_attributes_name_kana').dispatchEvent(event)

      document.querySelector('#store_corporation_attributes_zip_code').value = selected['post_code']
      document.querySelector('#store_corporation_attributes_zip_code').dispatchEvent(event)

      document.querySelector('#store_corporation_attributes_state').value = selected['prefecture_name']
      document.querySelector('#store_corporation_attributes_state').dispatchEvent(event)

      document.querySelector('#store_corporation_attributes_city').value = selected['city_name']
      document.querySelector('#store_corporation_attributes_city').dispatchEvent(event)

      document.querySelector('#store_corporation_attributes_street').value = selected['street_number']
      document.querySelector('#store_corporation_attributes_street').dispatchEvent(event)

      this.showModal = false
    },

    openDetail (corporateNumber) {
      window.open(`https://www.houjin-bangou.nta.go.jp/henkorireki-johoto.html?selHouzinNo=${corporateNumber}`, '_blank')
    },

    openModal () {
      // すごく気持ち悪いけど、とりあえず動くから良いことにする。
      this.corporateName = document.querySelector('#store_corporation_attributes_name').value
      this.showModal = true
      this.search()
    },

    async search () {
      const searchString = (this.corporateName || "").trim()
      if (searchString === "") return

      try {
        this.onSearch = true
        const response = await fetch(`/api/v1/corporates/search?name=${searchString}`).catch(e => { throw new Error(e) })
        if (! response.ok) throw new Error("API request failed.")
        this.searchResults = await response.json()
      } catch (e) {
        this.searchResults = []
        alert("検索に失敗しました。")
        console.error(e)
      } finally {
        this.searchResults.splice()
        this.onSearch = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-content {
  border: 0;
  width: 640px;
}

.modal-header {
  border: 0;

  .form-control {
    width: 480px;
  }

  .modal-action a {
    color: inherit;
  }
}

.modal-body {
  border: 0;
  height: 500px;
  overflow-y: scroll;
}

.modal-footer {
  border: 0;
}

.result-action {
  .material-icons {
    vertical-align: middle;
    font-size: 1.12rem;
  }
}
</style>
